import React, { useState, useEffect, useCallback } from 'react';
import { InputText, ImageUpload, DropdownField } from 'components/common/input';
import BaseModalForm from 'components/common/modal/BaseModalForm';
import ImageGallery from 'components/admin/common/ImageGallery';
import { Alert } from 'react-bootstrap';
import { useFormHandlers } from 'core/hooks/form/formHandlers';
import { MODAL_FORM_ERRORS } from 'core/constant/MODAL_FORM_ERRORS';

const EditBlogSlideModal = ({ show, slideSection, handleClose, handleSave, updating, errors, deleteSliderImage, requestError, initialImages, blogOptions }) => {
  const [formValues, setFormValues] = useState(slideSection);
  const [galleryImages, setGalleryImages] = useState(initialImages);
  const { handleChange, handleFileChangeLocal, handleRemoveImageLocal } = useFormHandlers(setFormValues);

  useEffect(() => {
    setFormValues(slideSection);
    setGalleryImages(initialImages);
  }, [slideSection, initialImages]);

  const handleSaveClick = useCallback(() => {
    handleSave({ ...formValues, id: slideSection?.id }, galleryImages);
  }, [formValues, slideSection?.id, handleSave, galleryImages]);

  return (
    <BaseModalForm show={show} title={slideSection?.id ? "Editar Sección de Diapositivas" : "Crear Sección de Diapositivas"} handleClose={handleClose} handleSave={handleSaveClick} updating={updating}>
      <div className="row">
      <div className="col-md-6 form-group">
          <DropdownField
            label="Blog"
            value={formValues?.blog_id}
            options={blogOptions}
            onChange={(e) => handleChange('blog_id', e.target.value)}
            placeholder="Seleccione el blog"
            error={errors.blog_id}
          />
        </div>
        <div className="col-md-6 form-group">
          <InputText
            label="Título de la Sección"
            value={formValues?.section_title}
            onChange={(e) => handleChange('section_title', e.target.value)}
            placeholder="Ingrese el título de la sección"
            error={errors?.section_title}
          />
        </div>
        <div className="col-md-6 form-group">
          <InputText
            label="Subtítulo de la Sección"
            value={formValues?.section_subtitle}
            onChange={(e) => handleChange('section_subtitle', e.target.value)}
            placeholder="Ingrese el subtítulo de la sección"
            error={errors?.section_subtitle}
          />
        </div>
        <div className="col-md-6 form-group">
          <ImageUpload
            label="Imagen de Fondo"
            value={formValues?.background_image}
            onFileChange={(e) => handleFileChangeLocal(e, 'background_image')}
            onRemoveImage={() => handleRemoveImageLocal('background_image')}
            error={errors.background_image}
          />
        </div>
        <div className="col-12 form-group">
          <h4>Galería de Imágenes de la Sección</h4>
          <ImageGallery initialImages={galleryImages} onImagesChange={setGalleryImages} onDeleteImage={deleteSliderImage} />
        </div>
        <div className="col-12 form-group mt-3">
          {requestError &&
            <Alert variant="danger">
              {requestError?.response?.data?.message ||
               MODAL_FORM_ERRORS.BLOG_SLIDE}
            </Alert>
          }
        </div>
      </div>
    </BaseModalForm>
  );
};

export default React.memo(EditBlogSlideModal);
